import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import AboutMenu from '../../components/menus/About';
import ContactBanner from '../../components/ContactBanner';
import Blogposts from './Blogposts';

function Blog({ builder, widget }) {
  const builderName = get(builder, 'name');
  const metaTitle = 'Latest News';
  const metaDescription = `Browse recent news and events on the ${builderName} blog`;
  const ogImage = '/images/facebook-og__blog.jpg';
  const ogImagePath = `https://${builder.authDomain}${ogImage}`;

  return (
    <PageWrapper builder={builder}>
      <PageHelmet
        custom
        title={metaTitle}
      >
        <meta name="description" content={metaDescription} />
        <meta property="og:image" content={buildThumbnailUrl(ogImagePath, { width: 1200, height: 1200 })} />
        <meta property="og:title" content={`${metaTitle} | ${builderName}`} />
        <meta property="og:description" content={metaDescription} />
      </PageHelmet>
      <InsideHeader
        title="The Latest News"
        postTitle={get(widget, 'page_subtitle')}
        background={get(widget, 'header_image.contentUrl')}
      />
      <AboutMenu />
      <main>
        <Blogposts />
      </main>
      <ContactBanner />
    </PageWrapper>
  );
}

Blog.propTypes = {
  builder: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

export default withData({
  builder: true,
  widget: 'blog',
})(Blog);



// WEBPACK FOOTER //
// ./src/pages/Blogposts/index.js